import { render, staticRenderFns } from "./today.vue?vue&type=template&id=5f61feed&scoped=true&"
import script from "./today.vue?vue&type=script&lang=js&"
export * from "./today.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f61feed",
  null
  
)

export default component.exports